import _asyncToGenerator from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import copy from 'clipboard-copy';
import toast from 'react-hot-toast';
export var copyTextToClipboard = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(text, config) {
    var success;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            success = true;
            _context.prev = 1;
            _context.next = 4;
            return copy(text);

          case 4:
            _context.next = 10;
            break;

          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](1);
            success = false;

            if (!(config !== null && config !== void 0 && config.hideUniversalErrorInfo)) {
              toast.error('Copy failed. Please check if the relevant configuration is enabled in your browser or copy manually.');
            }

          case 10:
            return _context.abrupt("return", {
              success: success
            });

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 6]]);
  }));

  return function copyTextToClipboard(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();